import { css } from 'styled-components';
import { baseHighlightStyle } from '../tokens/highlight';
export const buttonCursorMixin = css`
  ${baseHighlightStyle}
  ${({
  as,
  forwardedAs,
  onClick,
  href,
  inactive,
  disabled,
  clickable
}) => (onClick || href || clickable || as === 'button' || as === 'label' || as === 'a' || forwardedAs === 'button' || forwardedAs === 'label' || forwardedAs === 'a') && !inactive && !disabled && `
    cursor: pointer;
  `}
`;
export const buttonCursorKeys = ['as', 'forwardedAs', 'href', 'inactive', 'disabled', 'clickable', 'onClick'];